const prefix = 'BRANCH/SERVICES/POS';

export const GET_RECENT_TRANSACTIONS = `${prefix}/GET_RECENT_TRANSACTIONS`;
export const GET_SELECTED_RECENT_TRANSACTION = `${prefix}/GET_SELECTED_RECENT_TRANSACTION`;
